import React, { Component } from 'react'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import posed, { PoseGroup } from 'react-pose'
import easing from 'ui/styles/easing'

import Results from './Results'

// Animations
const PosedWrapper = posed.div({
  enter: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
})

// Styling
const Wrapper = styled(PosedWrapper)`
  height: 100vh;
  background: ${props => props.theme.colors[props.color].light};
  padding-top: 120px;
  overflow: scroll;
`

const Input = styled.input`
  font-size: 45px;
  text-align: center;
  padding-bottom: 35px;
  width: 100%;
  background: none;
  border: none;
  border-bottom: 2px solid ${props => props.theme.colors.grey.lightest};
  outline: none;
  color: ${props => props.theme.colors.grey.lightest};
  font-family: 'Hill';
  transition: transform 0.3s ${easing.easeOutCubic};

  ${media.md`
    font-size: 55px;
  `}

  ${media.xl`
    font-size: 70px;
  `}
`

export default class Search extends Component {
  constructor(props) {
    super(props)

    this.searchInput = React.createRef()
  }
  
  state = {
    searchString: 'Indtast søgeord'
  }
  
  render() {
    const {
      colorScheme,
      active
    } = this.props

    const { searchString } = this.state

    return(
      <PoseGroup withParent={false}>
        {active &&
          <Wrapper
            color={colorScheme}
            key="animatedSearch"
          >
            <Container fluid>

              <Row>
                <Col
                  sm={6}
                  smOffset={3}
                >
                  <Input
                    value={searchString}
                    onChange={e => this.setState({ searchString: e.target.value })}
                    onFocus={() => searchString !== 'Indtast søgeord' ? null : this.setState({ searchString: ''})}
                    onBlur={() => searchString !== '' ? null : this.setState({ searchString: 'Indtast søgeord' })}
                    color={colorScheme}
                    innerRef={this.searchInput}
                  />
                </Col>
              </Row>

              <Row>
                <Col
                  sm={6}
                  smOffset={3}
                >
                  <Results
                    search={searchString}
                    color={colorScheme}
                  />
                </Col>
              </Row>

            </Container>
          </Wrapper>
        }
      </PoseGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Search/index.js